import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TBusinessUnits } from '../types/types';

const initialState:
    {
        BusinessUnites: TBusinessUnits[]

    } = {
    BusinessUnites: []
}

const BusinessUnites = createSlice({
    name: 'busineesUnites',
    initialState,
    reducers: {
        addBusinessUnites: (state, action: PayloadAction<TBusinessUnits[]>) => {
            state.BusinessUnites = action.payload
        },
    },
});

export const { addBusinessUnites } = BusinessUnites.actions;

export default BusinessUnites.reducer;
